import { accountsQuery } from "@/services/lukita/queries";

export default async function getAccount() {
  const { accounts } = await accountsQuery();
  return accounts[0];
}
